const upgradeSubscriptionTypes = {
  full: 'FULL_UPGRADE',
  nonCharge: 'NONE_CHARGE_UPGRADE',
  partial: 'PARTIAL_UPGRADE',
}


export default upgradeSubscriptionTypes
